import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import { IconButton, Stack } from "@mui/material";
import { Check, Close, Preview } from "@mui/icons-material";
import dummyImage from "assets/images/userDummy.png";

export default function reportsTableData({ peopleList, onReject, onApprove, onView }) {
  const formatDate = (dateString) => {
    const date = new Date(dateString).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    return date;
  };
  const User = ({ image, name }) => {
    const imageSource = image ? image : dummyImage;
    return (
      <MDBox display="flex" alignItems="center" lineHeight={1}>
        <MDAvatar src={imageSource} alt={name} size="sm" />
        <MDBox ml={2} lineHeight={1}>
          <MDTypography display="block" variant="button" fontWeight="medium">
            {name}
          </MDTypography>
        </MDBox>
      </MDBox>
    );
  };

  return {
    columns: [
      { Header: "Reported By", accessor: "reported", width: "25%", align: "left" },
      { Header: "Preview", accessor: "preview", align: "left" },
      { Header: "Reason", accessor: "reason", align: "center" },
      { Header: "Uploaded By", accessor: "uploaded", width: "25%", align: "left" },
      { Header: "Reported At", accessor: "reportedAt", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],

    rows: peopleList.map((person) => ({
      reported: <User image={person?.reportedBy?.profile} name={person?.reportedBy?.name} />,
      preview: (
        <MDAvatar
          src={person?.videoData?.previewImg}
          variant="square"
          sx={{
            width: 60, 
            height: 60,
            borderRadius: 2, 
          }}
        />
      ),
      reason: (
        <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
          {person?.reason}
        </MDTypography>
      ),
      uploaded: <User image={person?.uploadedBy?.profile} name={person?.uploadedBy?.name} />,
      status: (
        <MDBox ml={-1}>
          <MDBadge
            badgeContent={person?.status}
            color={
              person?.status === "pending"
                ? "warning"
                : person?.status === "rejected"
                ? "error"
                : "success"
            }
            variant="gradient"
            size="sm"
          />
        </MDBox>
      ),
      reportedAt: (
        <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
          {formatDate(person?.reportedDate)}
        </MDTypography>
      ),
      actions: (
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <IconButton title="Preview" onClick={() => onView(person?.videoData?.videoUrl)}>
            <Preview />
          </IconButton>
          {person?.status === "pending" && (
            <>
              <IconButton
                color="success"
                title="Approve"
                onClick={() => onApprove(person?.id, person?.videoData?.id)}
              >
                <Check />
              </IconButton>
              <IconButton
                color="error"
                title="Reject"
                onClick={() => onReject(person?.id, person?.videoData?.id)}
              >
                <Close />
              </IconButton>
            </>
          )}
        </Stack>
      ),
    })),
  };
}
